import { getInitialsName } from '@repo/ui';
import { GetAllArchivedGroupsResponse } from 'domain/models';
import { GROUPS_ORDER_COLUMNS } from 'domain/value-objects/groups-order-columns';
import { TableColumn } from 'react-data-table-component';

export const makeColumnsArchivedGroupsList = (): TableColumn<
  GetAllArchivedGroupsResponse['data'][number]
>[] => {
  return [
    {
      name: 'Nome',
      selector: (row) => row.name,
      sortable: true,
      sortField: GROUPS_ORDER_COLUMNS.NAME,
      wrap: true,
      minWidth: '360px',
      maxWidth: '800px',
      cell: (row) => (
        <div>
          <span>{row.name}</span>
          <br />
          <span>
            {row.tags?.map((tag, idx) => (
              <span key={idx} className={`badge bg-${tag.color} me-1 mb-1`}>
                {tag.label}
              </span>
            ))}
          </span>
        </div>
      ),
    },
    {
      name: 'Código',
      selector: (row) => row.code,
      sortable: true,
      wrap: true,
      sortField: GROUPS_ORDER_COLUMNS.CODE,
      minWidth: '120px',
      maxWidth: '140px',
    },
    {
      name: 'Carga Horária',
      selector: (row) => row.workload?.total,
      sortable: true,
      sortField: GROUPS_ORDER_COLUMNS.WORKLOAD,
      minWidth: '220px',
      maxWidth: '240px',
      cell: (row) => (
        <span>
          {row.workload?.total && (
            <span>
              {row.workload?.total}h <span className="fs-11">Total | </span>
            </span>
          )}
          {row.workload?.week && (
            <span>
              {row.workload?.week}h <span className="fs-11">Sem | </span>
            </span>
          )}
          {row.workload?.day && (
            <span>
              {row.workload?.day}h <span className="fs-11">Dia</span>
            </span>
          )}
        </span>
      ),
    },
    {
      name: 'Dias',
      width: '250px',
      cell: (row) => {
        const days = {
          mon: 'S',
          tue: 'T',
          wed: 'Q',
          thu: 'Q',
          fri: 'S',
          sat: 'S',
          sun: 'D',
        };

        return (
          <>
            {Object.keys(days).map((day) => (
              <span
                key={day}
                style={{
                  backgroundColor: row.days[day] ? '#0AB39C' : '#7e7e7e',
                }}
                className="rounded-1 px-2 text-white me-1"
              >
                {days[day]}
              </span>
            ))}
          </>
        );
      },
    },
    {
      name: 'Professores',
      selector: (row) => row.workload?.total,
      sortable: true,
      sortField: GROUPS_ORDER_COLUMNS.TEACHERS,
      minWidth: '140px',
      maxWidth: '240px',
      cell: (row) => (
        <span>
          <div className="avatar-group">
            {row.teachers?.slice(0, 2).map((teacher) => (
              <div
                key={teacher?.id}
                title={teacher?.name}
                className="avatar-group-item"
              >
                {teacher?.avatar ? (
                  <img
                    src={teacher?.avatar}
                    alt="avatar"
                    className="rounded-circle avatar-xs"
                  />
                ) : (
                  <div
                    style={{ background: '#144c5b' }}
                    className="rounded-circle header-profile-user d-flex justify-content-center align-items-center"
                  >
                    <span
                      style={{ fontWeight: 600 }}
                      className="text-white text-text-decoration-none "
                    >
                      {getInitialsName(teacher?.name)}
                    </span>
                  </div>
                )}
              </div>
            ))}
            {row?.teachers && row?.teachers?.length > 2 && (
              <div className="avatar-group-item">
                <div className="avatar-xs">
                  <span className="avatar-title rounded-circle bg-primary text-white">
                    +{row?.teachers?.length}
                  </span>
                </div>
              </div>
            )}
          </div>
        </span>
      ),
    },
  ];
};
